import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const postReviewReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.POST_REVIEWS_START:
            return { ...state, loading: true, error: null };

        case types.POST_REVIEWS_SUCCESS:
            return { ...state, loading: false, data: action.payload, error: null };

        case types.POST_REVIEWS_ERROR:
            return { ...state, loading: false, error: action.payload };

        case types.POST_REVIEWS_RESET:
            return initialState;

        default:
            return state;
    }
};

export default postReviewReducer;
